module.exports = "/_next/static/images/ed20c5444e07f562da58cbc829037a17-open-graph-logo-large-br.png";